/**
 * The web-address (subdomain) rules and copy, shared by the company page's "App & web address"
 * section (moved here unchanged from the former Edit Organization dialog, W1).
 */

/** Same rule as the create wizard (and the API). */
export const SUBDOMAIN_PATTERN = /^[a-z0-9][a-z0-9-]*[a-z0-9]$/;
export const SUBDOMAIN_REQUIRED_ERROR = "Subdomain is required";
export const SUBDOMAIN_FORMAT_ERROR = "Subdomain must be alphanumeric with hyphens, cannot start/end with hyphen";
export const SUBDOMAIN_LOCKED_NOTE =
  "This company's own app has its name built in. Renaming it needs a new app release — ask engineering.";

/** What a subdomain change does — shown in the confirm before anything is saved. */
export const subdomainChangeWarnings = (next: string): string[] => [
  "Portal users must use the new address and sign in there",
  "App users stay signed in; anyone who signs out picks the company again from the list",
  `Its portal address becomes ${next}.portal.athlyn.app; the old address stops working`,
  `Its join link becomes athlyn.app/join/${next}; QR codes printed with the old name stop working`,
  "If the company signs in with Microsoft (Entra), agree the change with them first",
];

/** Trimmed and lower-cased, as the API stores it. */
export const normalizeSubdomain = (value: string | null | undefined): string => (value ?? "").trim().toLowerCase();
